import { styled, Flex, css } from '@goodrx/matisse';
import { mediaMinWidth } from 'app/lib/utils';

export const CtaContainer = styled(Flex)`
  height: ${(p) => p.theme.space[5]}px;
  background-color: ${(p) => p.theme.colors.greyLightest};
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;

  ${(p) =>
    css`
      border-bottom: 1px solid ${p.theme.colors.greyLight};
    `}

  ${mediaMinWidth({
    sm: `display: none;`,
  })};
`;
